import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import "./filter-sort-list-layout.scss";
import {query} from "lit/decorators/query.js";
import {SbkForm} from "@/components/form/form.ts";
import {SbkSelect} from "@/components/select/select.ts";

@customElement("sbk-filter-sort-list-layout")
export class SbkFilterSortListLayout extends LitElement {

  @query('.filter-form')
  _filterForm!: SbkForm

  @query('.result-list__title')
  _resultListTitle!: HTMLElement

  @query('.sort-form sbk-select')
  _sortingSelect!: SbkSelect

  async connectedCallback() {
    super.connectedCallback();
    if (this._sortingSelect) {
      await (<LitElement> this._sortingSelect).updateComplete;
      this._sortingSelect.addEventListener('select-value-changed', (e) => {
       e.preventDefault();
        this._submit();
      });
    }
    const url = window.location.href;
    if (url.includes('?')) {
      this._focusResultListTitle();
    }
  }

  protected createRenderRoot() {
    return this;
  }

  private _submit() {
    const form = this._sortingSelect.closest('form');
    if (!form) {
      return;
    }
    form.submit();
  }

  private _focusResultListTitle() {
    if (!this._resultListTitle) {
      return;
    }
    if (window.location.hash) {
      this._resultListTitle.focus();
    }
  }
}
